export default __webpack_public_path__ + "static/media/vdNT2eOvoT.b2f846b8.jpeg";